import { useSearchParams } from "react-router-dom";

interface IUseTabNavigationHook {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  tabs: readonly string[];
}
export const useTabNavigation = ({ activeTab, setActiveTab, tabs }: IUseTabNavigationHook) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setSearchParams] = useSearchParams();

  const handleSelectTab = (selectedTab?: string) => {
    const tab = selectedTab && tabs.includes(selectedTab) ? selectedTab : activeTab;

    setActiveTab(tab);
    setSearchParams({ tab });
  };

  const handleNextTab = () => {
    const currentIndex = tabs.findIndex((tab) => tab === activeTab);
    const tab = currentIndex < tabs.length - 1 ? tabs[currentIndex + 1] : activeTab;

    if (!tab) return;
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  const handlePrevTab = () => {
    const currentIndex = tabs.findIndex((tab) => tab === activeTab);
    const tab = currentIndex > 0 ? tabs[currentIndex - 1] : activeTab;

    if (!tab) return;
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  return {
    activeTab,
    handleSelectTab,
    handleNextTab,
    handlePrevTab,
  };
};
